// What riders are promised. The same points the server serves at GET /api/standards (riderHighlights), kept here so the page never waits for the server.
export const STANDARD_POINTS = [
  { title: 'Vehicles four years or newer', body: 'Every vehicle is a recent model year, never more than four years old.' },
  { title: 'Black exterior, inspected', body: 'Black vehicles, clean inside and out, and inspected at any time.' },
  { title: 'Suited chauffeurs', body: 'Every chauffeur is in a suit, on every ride.' },
  { title: 'Complimentary Voss water', body: 'Still Voss water for every rider.' },
  { title: 'Chargers on board', body: 'USB-C and iPhone chargers within reach, plus an umbrella, tissues and mints.' },
];
export const STANDARDS_SHORT = 'Vehicles four years or newer · Black, inspected vehicles · Suited chauffeurs · Complimentary Voss water · Chargers on board';
